module.exports = __webpack_public_path__ + "static/img/money-line.9e81054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/money-line.png
// module id = vhvE
// module chunks = 18